/** @jsx jsx */
import {
  Modal,
  ModalActionButton,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalHeading,
  ModalProps,
} from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { IJobRequestConsent } from "@/data/job-requests";
import { HtmlRenderer } from "@/eworkitMove/HtmlRenderer";

interface ApplyConsentModalProps extends ModalProps {
  consent: IJobRequestConsent;
}

export const ApplyConsentModal: FC<ApplyConsentModalProps> = ({ consent, ...modalProps }) => {
  const { t } = useTranslation("session");

  return (
    <Modal aria-label={t("JOB_REQUESTS.APPLY.CONSULTANT_PROFILE_FORM.MODAL_TITLE_CONSENT")} {...modalProps}>
      <ModalContainer>
        <ModalHeader
          onCloseClick={modalProps.dialogState.hide}
          closeButtonAriaLabel={t("COMPONENTS.MODAL.CLOSE")}
          headerPlaceholder={
            <ModalHeading>{t("JOB_REQUESTS.APPLY.CONSULTANT_PROFILE_FORM.MODAL_TITLE_CONSENT")}</ModalHeading>
          }
        />

        <ModalContent>
          <HtmlRenderer html={consent.content} />
        </ModalContent>

        <ModalFooter>
          <ModalActionButton type="button" variant="primary" onClick={modalProps.dialogState.hide}>
            {t("JOB_REQUESTS.APPLY.WIZARD.CLOSE_CONSENT_PREVIEW_BUTTON")}
          </ModalActionButton>
        </ModalFooter>
      </ModalContainer>
    </Modal>
  );
};
